import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import MuralLoading from "@/client/modules/mural/loading";
import { MuralClient } from "@/client/modules/mural/mural-client";

type Search = { todos?: string };

export const Route = createFileRoute("/app/mural")({
  validateSearch: (s: Record<string, unknown>): Search => ({ todos: s.todos as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("mural", "page", deps)),
  head: () => pageHead("Mural"),
  pendingComponent: MuralLoading,
  component: MuralPage,
});

function MuralPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("mural", "page", search);
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Mural" description="Avisos, lembretes e combinados da equipe." />
      <MuralClient posts={data.posts} currentUser={data.currentUser} allUsers={data.allUsers} />
      {data.hasMore && (
        <div className="flex justify-center">
          <Link
            to="/app/mural"
            search={{ todos: "1" }}
            className="rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 shadow-soft transition hover:bg-slate-50"
          >
            Ver posts mais antigos
          </Link>
        </div>
      )}
    </div>
  );
}
